var minimum_units = 50;
var step3_minimum_units = 50;
var minimum_quantity = 10;

$(document).ready(function () {

    // Init
    getProductUrl();

    Init();

    // Scroll if url contains hashtag
    scrollToDivIdWithHashtag('#block__corporate-step-1', 'block__corporate-step-1');

    $('.corporate-step-1-display-float').click(function () {
        $('.corporate-step-1-display-float').each(function () {
            $(this).removeClass('active');
        });
        $(this).addClass('active');
        scrollToDivId('block__corporate-step-2');
        getProductUrl(url = $(this).data('type'));
    });

    $('.corporate-change-quantity').click(function () {
        let quantity = 0;
        let old_quantity = parseInt($('.container.step input[name=quantity]').val());
        if ($(this).data('func') == 'minus') {
            if (old_quantity > minimum_quantity) {
                $('.container.step input[name=quantity]').val(old_quantity - 1);
            } else {
                $.confirm({
                    title: 'CONFIRM',
                    content: 'Minimum ' + minimum_quantity + ' units',
                    type: 'orange',
                    typeAnimated: true,
                    buttons: {
                        tryAgain: {
                            text: 'Continue',
                            btnClass: 'btn-orange',
                            action: function () {
                                //
                            }
                        }
                    }
                });
            }
        } else {
            $('.container.step input[name=quantity]').val(old_quantity + 1);
        }

        if (quantity < minimum_units) {
            // $('.corporate-step-3-display-float:nth-of-type(2)').removeClass('active');
            $('.corporate-step-4-display-float:nth-of-type(6)').removeClass('active');
        }

        let new_quantity = parseInt($('.container.step input[name=quantity]').val());
        let price_gift_box = abridgedNumber(parseFloat($('input[name="price_gift_box"]').val()) * new_quantity);
        $('.corporate-step-2-qty-right span').text('$' + price_gift_box.toFixed(2));

        // update step 2 in step 6
        $('.corporate-step-6 table tr:nth-of-type(2) td:nth-of-type(2)').text(new_quantity);
        $('.corporate-step-6 table tr:nth-of-type(2) td:nth-of-type(3)').text('$' + price_gift_box.toFixed(2));
        // end

        updateStep_6_3(new_quantity);
        updateStep_6_4(new_quantity);
        updateStep_6_5(new_quantity);

        totalPrice();
    });

    $('.container.step input[name=quantity]').keyup(function (event) {
        let quantity = $(this).val();
        if (!quantity) {
            quantity = 0;
        }
        let price_gift_box = abridgedNumber(parseFloat($('input[name="price_gift_box"]').val()) * parseInt(quantity));
        let price_gift_box_text = '$' + price_gift_box.toFixed(2);
        $('.corporate-step-2-qty-right span').text(price_gift_box_text);

        // update step 2 in step 6
        $('.corporate-step-6 table tr:nth-of-type(2) td:nth-of-type(2)').text(quantity);
        $('.corporate-step-6 table tr:nth-of-type(2) td:nth-of-type(3)').text(price_gift_box_text);
        // end

        updateStep_6_4(quantity);
        updateStep_6_5(quantity);

        totalPrice();
    });

    $('.corporate-step-final-display').slick({
        prevArrow: '',
        nextArrow: '<button type="button" class="slick-next" style="margin-top:20px">Next</button>',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        adaptiveHeight: true,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.corporate-step-3-display-float').click(function () {
        let quantity = parseInt($('.container.step input[name=quantity]').val());
        let minimum_units_this = $(this).data('minimum-units');
        if (minimum_units_this == step3_minimum_units && step3_minimum_units > quantity) {
            $.confirm({
                title: 'CONFIRM',
                content: 'Minimum ' + step3_minimum_units + ' units',
                type: 'orange',
                typeAnimated: true,
                buttons: {
                    tryAgain: {
                        text: 'Continue',
                        btnClass: 'btn-orange',
                        action: function () {
                            scrollToDivId('block__corporate-step-2');
                        }
                    }
                }
            });

            return false;
        }

        $('.corporate-step-3-display-float').each(function () {
            $(this).removeClass('active');
        });
        $(this).addClass('active');
        scrollToDivId('block__corporate-step-5');

        // update step 3 in step 6
        $('.corporate-step-6 table tr:nth-of-type(3) td:nth-of-type(2)').text($(this).data('title'));
        let price = parseFloat($(this).data('price').substring(1));
        let total_price = abridgedNumber(parseFloat(price * quantity)).toFixed(2);
        $('.corporate-step-6 table tr:nth-of-type(3) td:nth-of-type(3)').text('$' + total_price);
        // end

        if (price > 0) {
            $('.has-custom-option.extra-label-step-3').removeClass('hidden')
            $('.show-if-custom.summary-custom').removeClass('hidden')
        } else {
            $('.has-custom-option.extra-label-step-3').addClass('hidden')
            if ($('.has-custom-option.extra-label-step-4').hasClass('hidden')) {
                $('.show-if-custom.summary-custom').addClass('hidden')
            }
        }

        totalPrice();
    });

    $('.corporate-step-4-display-float').click(function () {
        let quantity = parseInt($('.container.step input[name=quantity]').val());
        let minimum_units_this = $(this).data('minimum-units');
        if (minimum_units_this == minimum_units && minimum_units > quantity) {
            $.confirm({
                title: 'CONFIRM',
                content: 'Minimum ' + minimum_units + ' units',
                type: 'orange',
                typeAnimated: true,
                buttons: {
                    tryAgain: {
                        text: 'Continue',
                        btnClass: 'btn-orange',
                        action: function () {
                            scrollToDivId('block__corporate-step-2');
                        }
                    }
                }
            });

            return false;
        }

        $('.corporate-step-4-display-float').each(function () {
            $(this).removeClass('active');
        });
        $(this).addClass('active');
        scrollToDivId('block__corporate-step-4-sub');

        // update step 4 in step 6
        $('.corporate-step-6 table tr:nth-of-type(4) td:nth-of-type(2)').text($(this).data('title'));
        let price = parseFloat($(this).data('price').substring(1));
        let total_price = abridgedNumber(price * quantity).toFixed(2);
        $('.corporate-step-6 table tr:nth-of-type(4) td:nth-of-type(3)').text('$' + total_price);
        // end

        if (price > 0) {
            $('.has-custom-option.extra-label-step-4').removeClass('hidden')
            $('.show-if-custom.summary-custom').removeClass('hidden')
        } else {
            $('.has-custom-option.extra-label-step-4').addClass('hidden')
            if ($('.has-custom-option.extra-label-step-3').hasClass('hidden')) {
                $('.show-if-custom.summary-custom').addClass('hidden')
            }
        }

        totalPrice();
    });

    $('.corporate-step-5-display-float').click(function () {
        if (!checkSelectedFirstStep()) {
            scrollToDivId('block__corporate-step-1');
            alert('Please select step 1!');
            return false;
        }
        $('.corporate-step-5-display-float').each(function () {
            $(this).removeClass('active');
        });
        $(this).addClass('active');
        scrollToDivId('block__corporate-step-6');

        // update step 5 in step 6
        let quantity = parseInt($('.container.step input[name=quantity]').val());
        $('.corporate-step-6 table tr:nth-of-type(5) td:nth-of-type(2)').text($(this).data('title'));
        let price = parseFloat($(this).data('price').substring(1));
        let total_price = abridgedNumber(price * quantity).toFixed(2);
        $('.corporate-step-6 table tr:nth-of-type(5) td:nth-of-type(3)').text('$' + total_price);
        // end

        totalPrice();
    });

    $("button[name='confirm-your-corporate']").click(function (e) {
        e.preventDefault();
        if (!checkSelectedFirstStep()) {
            scrollToDivId('block__corporate-step-1');
            alert('Please select step 1!');
            return false;
        }

        let note = $('.block__corporate-step-4-sub textarea[name="corporate_message"]').val();
        let quantity = parseInt($('.corporate-step-2-qty input[name="quantity"]').val());
        if (quantity < minimum_quantity) {
            $.confirm({
                title: 'CONFIRM',
                content: 'Minimum ' + minimum_quantity + ' units',
                type: 'orange',
                typeAnimated: true,
                buttons: {
                    tryAgain: {
                        text: 'Continue',
                        btnClass: 'btn-orange',
                        action: function () {
                            scrollToDivId('block__corporate-step-2');
                        }
                    }
                }
            });
            return false;
        }

        let items = [{
            quantity: quantity,
            id: $('.corporate-step-5-display-float.active').data('id'),
            "properties[corporate_gift]": "1",
        },
            {
                quantity: quantity,
                id: $('.corporate-step-4-display-float.active').data('id'),
                "properties[corporate_gift]": "1",
            },
            {
                quantity: quantity,
                id: $('.corporate-step-3-display-float.active').data('id'),
                "properties[corporate_gift]": "1",
            },
            {
                quantity: quantity,
                id: $('.corporate-step-1-display-float.active').data('id'),
                "properties[corporate_gift]": "1",
            }
        ];

        $.post('/cart/add.js', {
            items: items,
            note: note
        }).done(function () {
            $.confirm({
                title: 'CONFIRM',
                content: 'Thank you for your order</br>We will email you a link to upload shipping addresses, a logo, a custom design greeting card & messages (if applicable).',
                type: 'green',
                typeAnimated: true,
                buttons: {
                    tryAgain: {
                        text: 'Go to your Cart',
                        btnClass: 'btn-green',
                        action: function () {
                            window.location.href = "https://succulentsbox.com/cart";
                        }
                    }
                }
            });
        }).fail(function (error) {
            let response = JSON.parse(error.responseText);
            $.confirm({
                title: 'CONFIRM',
                content: response.description,
                type: 'red',
                typeAnimated: true,
                buttons: {
                    tryAgain: {
                        text: 'Try again',
                        btnClass: 'btn-red',
                        action: function () {
                        }
                    }
                }
            });
        });
    });

    // $('.corporate-step-final-testimonial p').readmore({
    //     collapsedHeight: 108
    // });

    if (detectMobile()) {
        $('.corporate-step-final iframe').attr('height', 200);
    }
});

function scrollToDivId(div_id) {
    if (detectMobile()) {
        let height_scroll = $('body').hasClass('promo_banner-show') ? 70 : 100;
        $('html, body').animate({
            scrollTop: $('#' + div_id).offset().top - height_scroll
        }, 1000);
    } else {
        $('html, body').animate({
            scrollTop: $('#' + div_id).offset().top - 60
        }, 1000);
    }
}

function scrollToDivIdWithHashtag(hashtag, div_id) {
    if (window.location.hash == hashtag) {
        scrollToDivId(div_id);
    }
}

function detectMobile() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}

function checkSelectedFirstStep() {
    let bool = false;
    $('.corporate-step-1-display-float').each(function () {
        if ($(this).hasClass('active')) {
            bool = true;
            return false;
        }
    });
    return bool;
}

function getProductUrl(url = '') {
    product_url = url ? url : $('.corporate-step-1-display-float.active').data('type');
    jQuery.ajax({
        dataType: 'json',
        url: 'https://succulentsbox.com/products/' + product_url + '.json',
        async: true,
        success: function (data) {
            $('.corporate-step-2-img img').attr('src', data.product.image.src).attr('alt', data.product.title);
            $('.corporate-step-2-text h2').text(data.product.title);

            let des_arr = data.product.body_html.split('<!-- split -->');
            if (des_arr[1]) {
                $('.corporate-step-2-des').html(des_arr[1]);
            } else {
                $('.corporate-step-2-des').html('');
            }

            $('.corporate-step-2-review').html($('.reviews-' + product_url).val());

            $('.corporate-step-2-price span:nth-of-type(1)').text("");
            $('.corporate-step-2-price span:nth-of-type(2)').text("");
            $('.corporate-step-2-price span:nth-of-type(3)').text("");

            let price = parseFloat(data.product.variants[0].price);
            let compare_at_price = parseFloat(data.product.variants[0].compare_at_price);
            let quantity = $('.container.step input[name=quantity]').val();

            // init step 1 and step 2 in step 6
            $('.corporate-step-6 table tr:nth-of-type(1) td:nth-of-type(2)').text(data.product.title);
            $('.corporate-step-6 table tr:nth-of-type(1) td:nth-of-type(3)').text('$' + price.toFixed(2));
            $('.corporate-step-6 table tr:nth-of-type(2) td:nth-of-type(2)').text(quantity);
            $('.corporate-step-6 table tr:nth-of-type(2) td:nth-of-type(3)').text('$' + abridgedNumber(price * parseInt(quantity)).toFixed(2));
            // end

            // init step 2
            $('.corporate-step-2-price span:nth-of-type(1)').text('$' + price);
            $('input[name=price_gift_box]').val(price);
            $('.corporate-step-2-qty-right span').text('$' + (price * quantity).toFixed(2));
            if (compare_at_price && price < compare_at_price) {
                $('.corporate-step-2-sale').show();
                $('.corporate-step-2-price span:nth-of-type(2)').text('$' + compare_at_price.toFixed(2));
                let salePercent = 100 - (price / compare_at_price) * 100;
                let savePrice = abridgedNumber(compare_at_price - price);
                $('.corporate-step-2-price span:nth-of-type(3)').text("You save " + Math.floor(salePercent) + "%" + " ($" + savePrice.toFixed(2) + " )");
            } else {
                $('.corporate-step-2-sale').hide();
            }
            // end

            totalPrice();
        }
    });
}

function Init() {
    let quantity = parseInt($('.container.step input[name=quantity]').val());

    // init step 3 in step 6
    $('.corporate-step-6 table tr:nth-of-type(3) td:nth-of-type(2)').text($('.corporate-step-3-display-float.active').data('title'));
    $('.corporate-step-6 table tr:nth-of-type(3) td:nth-of-type(3)').text('$0.00');
    // end

    // init step 4 in step 6
    let corporate_step_4_display_float_active = $('.corporate-step-4-display-float.active');
    let corporate_step_4_price = parseFloat(corporate_step_4_display_float_active.data('price').substring(1));
    let corporate_step_4_total_price = abridgedNumber(quantity * corporate_step_4_price);
    $('.corporate-step-6 table tr:nth-of-type(4) td:nth-of-type(2)').text(corporate_step_4_display_float_active.data('title'));
    $('.corporate-step-6 table tr:nth-of-type(4) td:nth-of-type(3)').text('$' + corporate_step_4_total_price.toFixed(2));
    // end

    // init step 5 in step 6
    let corporate_step_5_display_float_active = $('.corporate-step-5-display-float.active');
    let corporate_step_5_price = parseFloat(corporate_step_5_display_float_active.data('price').substring(1));
    let corporate_step_5_total_price = abridgedNumber(quantity * corporate_step_5_price);
    $('.corporate-step-6 table tr:nth-of-type(5) td:nth-of-type(2)').text(corporate_step_5_display_float_active.data('title'));
    $('.corporate-step-6 table tr:nth-of-type(5) td:nth-of-type(3)').text('$' + corporate_step_5_total_price.toFixed(2));
    // end
}

function totalPrice() {
    let count = 1;
    let total_price = 0;
    $('.corporate-step-6 table tr td:nth-of-type(3)').each(function () {
        if (count > 1 && count < 6) {
            total_price += parseFloat($(this).text().substring(1));
        }
        count++;
    });
    // update total price in step 6
    $('.corporate-step-6 table tr:nth-of-type(6) td:nth-of-type(3)').text('$' + total_price.toFixed(2));
    // end
}

function updateStep_6_3(quantity) {
    let corporate_step_3_display_float_active = $('.corporate-step-3-display-float.active');
    let corporate_step_3_price = corporate_step_3_display_float_active.length > 0 ? parseFloat(corporate_step_3_display_float_active.data('price').substring(1)) : 0;
    let corporate_step_3_total_price = abridgedNumber(quantity * corporate_step_3_price);
    $('.corporate-step-6 table tr:nth-of-type(3) td:nth-of-type(3)').text('$' + corporate_step_3_total_price.toFixed(2));
    if (corporate_step_3_price > 0) {
        $('.has-custom-option.extra-label-step-3').removeClass('hidden')
        $('.show-if-custom.summary-custom').removeClass('hidden')
    } else {
        $('.has-custom-option.extra-label-step-3').addClass('hidden')
        if ($('.has-custom-option.extra-label-step-4').hasClass('hidden')) {
            $('.show-if-custom.summary-custom').addClass('hidden')
        }
    }
}

function updateStep_6_4(quantity) {
    let corporate_step_4_display_float_active = $('.corporate-step-4-display-float.active');
    let corporate_step_4_price = corporate_step_4_display_float_active.length > 0 ? parseFloat(corporate_step_4_display_float_active.data('price').substring(1)) : 0;
    let corporate_step_4_total_price = abridgedNumber(quantity * corporate_step_4_price);
    $('.corporate-step-6 table tr:nth-of-type(4) td:nth-of-type(3)').text('$' + corporate_step_4_total_price.toFixed(2));
    if (corporate_step_4_total_price > 0) {
        $('.has-custom-option.extra-label-step-4').removeClass('hidden')
        $('.show-if-custom.summary-custom').removeClass('hidden')
    } else {
        $('.has-custom-option.extra-label-step-4').addClass('hidden')
        if ($('.has-custom-option.extra-label-step-3').hasClass('hidden')) {
            $('.show-if-custom.summary-custom').addClass('hidden')
        }
    }
}

function updateStep_6_5(quantity) {
    let corporate_step_5_display_float_active = $('.corporate-step-5-display-float.active');
    let corporate_step_5_price = parseFloat(corporate_step_5_display_float_active.data('price').substring(1));
    let corporate_step_5_total_price = abridgedNumber(quantity * corporate_step_5_price);
    $('.corporate-step-6 table tr:nth-of-type(5) td:nth-of-type(3)').text('$' + corporate_step_5_total_price.toFixed(2));
}

function abridgedNumber(number) {
    return (Math.round((number + Number.EPSILON) * 100) / 100);
}